import React, {useState} from 'react';
import styles from './CommsSimulator.module.scss'
import InteractionContainer from "../../partials/InteractionContainer/InteractionContainer";
import Button, {ButtonsHolder} from "../../partials/Button";
import Instructions from "../../partials/Instructions/Instructions";
import Scroll from "../../partials/Scroll/Scroll";
import HTMLContent from "../../partials/HTMLContent";
import FeedBack from "../Orbits/QuizV2/FeedBack/FeedBack";
import Media from "../../partials/Media";
import _ from "lodash";
import axios from "axios";

const Section = ({section, className, disableContinue= false,onContinue = () => {}, onRetry = () => {},  isCollapsed = true, children = <></>}) => {

    const onDownload = () => {
        download(`docs/${section?.downloadFile}`, section?.downloadFile )

    }
    if (!section) return null

    return <div className={`${styles.Section} ${className}`} >
        <div className={`${styles.Header} ${!isCollapsed ? styles.Current : ''}`}>{section?.header || 'Invalid section header'}</div>
        <div className={`${styles.Content} ${isCollapsed ? styles.Collapsed : ''}`} >
            <Scroll>
                <div className={styles.Container}>
                    <HTMLContent html={section?.body || ''}>  </HTMLContent>
                    {section?.bodyBefore && <HTMLContent html={section?.bodyBefore || ''}>  </HTMLContent>}
                    {children}
                    {section?.bodyAfter && <HTMLContent html={section?.bodyAfter || ''}>  </HTMLContent>}
                    </div>

            </Scroll>
            <ButtonsHolder orientation={'right'}>
                {section?.downloadFile && section?.downloadFile    !== '' && <Button text={section.downloadCaption} onClick={onDownload}/>}
                {section?.retryCaption && section?.retryCaption    !== '' && <Button text={section.retryCaption} onClick={onRetry}/>}
                {section?.continueCaption && section?.continueCaption !== '' && <Button disabled={disableContinue === true}  text={section.continueCaption} onClick={onContinue} />}
            </ButtonsHolder>
        </div>
    </div>
}

function CommsSimulator(props) {
    const [simulationResult, setSimulationResult] = React.useState({
        header: "Oh no!",
        isSuccess: false,
        feedback: 'N/A',
        imgUrl:  false,
    })
    const { introductionSection, inputValuesSection, simulationSection } = props?.data
    const [collapsedState, setCollapsedState] = useState({
        introduction: false,
        inputValues: true,
        simulation: true,
    })
    const [currentValues, setCurrentValues] = React.useState(() => {
        if (!inputValuesSection?.fields) return {}
        const initial = {};
            inputValuesSection.fields.forEach(field => {
                initial[field.key] =  false
            })

        return initial
    })
    const [isInvalid, setIsInvalid] = React.useState(true)
    const expandSection = (sectionToExpand) => {
        const newState = {...collapsedState}
        Object.keys(collapsedState).map(k => {
            if (k === sectionToExpand) {
                newState[sectionToExpand] = false
                return
            }
            newState[k] = true
        })
        setCollapsedState(newState)
    }
    const simulate = () => {

        const isGoodParams = _.isEqual(simulationSection.correctParams,
                    currentValues

            )

       setSimulationResult({
           header: isGoodParams ? simulationSection.positiveFeedbackHeader : simulationSection.negativeFeedbackHeader,
           isSuccess: isGoodParams,
           feedback: isGoodParams ? simulationSection.positiveFeedback : simulationSection.negativeFeedback,
           imgUrl:  isGoodParams ? simulationSection.positiveImgUrl : simulationSection.negativeImgUrl,
       })

       expandSection('simulation')
    }
    React.useEffect( () => {
    }, [simulationResult])
    const handleSelectionChange = (e, key) => {
        const newValues = {...currentValues}
        newValues[key] = e.currentTarget.value
        setCurrentValues(newValues)
    }
    React.useEffect(()=> {
        const invalid = Object.keys(currentValues).some( k => currentValues[k]=== false)
        setIsInvalid(invalid)
    } , [currentValues])
    console.log(props.data)
    return <InteractionContainer
        withFrame={props.data?.doFrame === "TRUE"}
        variant={props?.data?.background || 'grid'}
        breadcrumbs={props?.breadcrumbs || ""}>
        <Instructions body={props?.data?.intro || "Invalid intro data"} />
        <div className="back-btn-container">
            <Button variant='back' text="Back" onClick={props.goBackToPreviousSegment} />
        </div>
        <div className={styles.CommsSimulator} >
            <div className={styles.Sections}>
                <Section  section={introductionSection}
                          onContinue={ () => expandSection('inputValues')}
                          className={styles.Introduction}
                          isCollapsed={collapsedState.introduction} />

                <Section  section={inputValuesSection}
                          className={styles.InputValues}
                          onContinue={simulate}
                          disableContinue={isInvalid}

                          onRetry={() => expandSection('introduction')}
                          isCollapsed={collapsedState.inputValues}>

                    <div className={styles.Fields}>
                    {inputValuesSection?.fields && inputValuesSection.fields.map(field => {
                            return <div className={styles.InputFields} key={field.caption}>
                                    <div className={styles.Field} >
                                        {field.caption}
                                    </div>
                                    <div className={styles.Input} >
                                            <select onChange={(e) => handleSelectionChange(e, field.key)} >
                                                <option value={false}>Choose</option>
                                                {field.options && field.options.map( (option) =>  {
                                                    return <option key={option} >{option}</option>
                                                })}
                                            </select>
                                    </div>
                                    <div className={styles.Unit}>
                                        {field.unit}

                                    </div>


                            </div>
                    })}
                    </div>



                </Section>
                <Section  section={simulationSection}
                          className={styles.Simulation}
                          onContinue={ () => props.onComplete() }
                          onRetry={() => expandSection('inputValues') }

                          isCollapsed={collapsedState.simulation}>

                            <div className={styles.FeedBackContainer}>
                                <div className={styles.FeedBackBox} >
                                  <FeedBack variant={simulationResult.isSuccess ? 'success' : 'failure'}
                                            title={simulationResult.header}
                                            innerHTML={simulationResult.feedback}
                                  />
                                </div>

                                <div className={styles.FeedBackMedia}>
                                    {simulationResult.imgUrl && <Media variant={''}
                                        src={simulationResult.imgUrl}
                                        caption={''}
                                        type={'image'}
                                    ></Media>}
                                    </div>
                                </div>



                </Section>
            </div>
        </div>
        <ButtonsHolder orientation={'right'} variant={'fixed-bottom'}>
            <Button onClick={()=>props.onComplete()} text={props?.data?.completeButtonCaption || 'NEXT'} ></Button>
        </ButtonsHolder>
    </InteractionContainer>
}

function download(url, fileName) {
    axios({
        url: url,
        method: 'GET',
        responseType: 'blob'
    })
        .then((response) => {
            const url = window.URL
                .createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
        .catch(e  => {
            console.error(e.message);
            alert('Unable to download file');
        })
}
export default CommsSimulator;


